// Ordem de numeração das portas por carro — muda de acordo com o fabricante/modelo
// do trem. Usado tanto pra montar as chaves de telemetria (buildDoorMatrixData)
// quanto pra desenhar os números na tela (DoorsMatrix) — as duas pontas precisam
// usar exatamente essa mesma regra, ou o número exibido não bate com o dado lido.
//
// 8900 (Alstom / Alfa): carros 1-4 numeração normal (8 7 6 5 / 1 2 3 4),
//                       carros 5-8 invertida (4 3 2 1 / 5 6 7 8).
// 7500 (CAF / Charlie): alterna a cada 2 carros — (1,2) normal, (3,4)
//                       invertida, (5,6) normal, (7,8) invertida. Confirmado
//                       tanto pro número exibido quanto pro grid de status
//                       (mesma regra, validada com telemetria real do C59).
//
// Único ponto de validação de "carro invertido" do sistema — tanto os
// números (DoorsMatrix/DoorLayout) quanto o grid de status
// (buildDoorMatrixData) chamam essa mesma função, nenhum dos dois tem sua
// própria cópia da regra.
import { TIPO_TREM, TIPO_TREM_FALLBACK } from "./tipoTrem";

export { TIPO_TREM, TIPO_TREM_FALLBACK };

export function isCarroInvertido(carro, tipoTrem = TIPO_TREM_FALLBACK) {
    if (tipoTrem === TIPO_TREM.TREM_7500) {
        const grupo = Math.floor((carro - 1) / 2);
        return grupo % 2 === 1;
    }

    // 8900 — também usado como fallback pra trens sem tipo definido.
    return carro >= 5;
}

export function getDoorNumbers(carro, tipoTrem = TIPO_TREM_FALLBACK) {
    const invertido = isCarroInvertido(carro, tipoTrem);

    if (!invertido) {
        return {
            top: [8, 7, 6, 5],
            bottom: [1, 2, 3, 4]
        };
    }

    // Carro invertido: a fileira de cima sempre decresce a partir de 4;
    // a de baixo muda conforme o tipo — 8900 continua decrescente (8 7 6 5),
    // 7500 é crescente (5 6 7 8).
    return {
        top: [4, 3, 2, 1],
        bottom: tipoTrem === TIPO_TREM.TREM_7500 ? [5, 6, 7, 8] : [8, 7, 6, 5]
    };
}
